import { NavLink, Navigate, Outlet } from 'react-router-dom';

import { Button } from '../components/ui/Button.jsx';
import { Spinner } from '../components/ui/Spinner.jsx';
import { ThemeToggle } from '../components/layout/ThemeToggle.jsx';
import { useTranslation } from '../i18n/useTranslation.js';

import { usePlatformAuth } from './PlatformAuthContext.jsx';
import './platform.css';

/**
 * Rahmen der Anbieterebene.
 *
 * Ausdrücklich NICHT die AppShell: dort hängt die Modulnavigation einer
 * Kundenfirma. Hier gibt es nur Anbieterthemen, und die Akzentkante oben plus
 * das Kennzeichen in der Kopfleiste machen jederzeit sichtbar, auf welcher
 * Ebene man gerade arbeitet.
 */
export function PlatformShell() {
  const { account, isAuthenticated, isBootstrapping, signOut } = usePlatformAuth();
  const { t } = useTranslation();

  if (isBootstrapping) {
    return (
      <div className="pf-login">
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/platform/login" replace />;
  }

  return (
    <div className="pf-shell">
      <div className="pf-topline" aria-hidden="true" />
      <header className="pf-header">
        <span className="pf-brand">
          <span className="pf-mark" aria-hidden="true" />
          <span>RSZ ERP</span>
          <span className="pf-badge">{t('platform.badge')}</span>
        </span>

        <nav className="pf-nav">
          <NavLink to="/platform/tenants">{t('platform.nav.tenants')}</NavLink>
          <NavLink to="/platform/demo-requests">{t('platform.nav.demoRequests')}</NavLink>
        </nav>

        <span className="pf-right">
          <span className="pf-account">{account?.email}</span>
          <ThemeToggle />
          <Button variant="ghost" size="sm" onClick={signOut}>
            {t('platform.signOut')}
          </Button>
        </span>
      </header>

      <main className="pf-main">
        <Outlet />
      </main>
    </div>
  );
}
